import i18n from 'i18next'
import LanguageDetector from 'i18next-browser-languagedetector'
import { initReactI18next } from 'react-i18next'
import IT from './locales/it.locale.json'
import DE from './locales/de.locale.json'

const resources = {
  it: {
    translation: IT,
  },
  de: {
    translation: DE,
  },
}

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'it',
    debug: true,

    // keySeparator: false, // we use content as keys
    interpolation: {
      escapeValue: false,
    },
  })

export default i18n
